import { SettingsIcon } from 'lucide-react';
import { FormikErrors } from 'formik';

import { RelativePathFieldset } from '@/react/portainer/gitops/RelativePathFieldset/RelativePathFieldset';
import { SourceId } from '@/react/portainer/gitops/sources/types';

import { Card } from '@@/primitives/Card';
import { SwitchField } from '@@/form-components/SwitchField';

import { ArtifactConfig } from '../../type';
import { DeploymentType } from '../../detectDeploymentType';

export function AdvancedConfiguration({
  values,
  setFieldValue,
  refName,
  sourceId,
  errors,
  deploymentType,
}: {
  values: ArtifactConfig;
  setFieldValue: <K extends keyof ArtifactConfig>(
    f: K,
    v: ArtifactConfig[K]
  ) => void;
  errors: FormikErrors<ArtifactConfig> | undefined;
  refName: string | undefined;
  sourceId: SourceId | undefined;
  deploymentType: DeploymentType;
}) {
  return (
    <Card.Container>
      <Card.Header title="Advanced configurations" icon={SettingsIcon} />
      <Card.Body>
        {deploymentType === DeploymentType.Kubernetes && (
          <SwitchField
            label="Use namespace(s) specified from manifest"
            data-cy="use-manifest-namespaces-switch"
            tooltip="If you have defined namespaces in your deployment file, turning this on will enforce the use of those only in the deployment."
            checked={values.useManifestNamespaces}
            onChange={(value) => setFieldValue('useManifestNamespaces', value)}
          />
        )}

        <RelativePathFieldset
          values={values.relativePath}
          onChange={(relativePath) =>
            setFieldValue('relativePath', relativePath)
          }
          gitModel={{ RepositoryReferenceName: refName, SourceId: sourceId }}
          errors={errors?.relativePath}
        />
      </Card.Body>
    </Card.Container>
  );
}
